import originalAxios from 'axios'
import apiErrorHandler from 'common/utils/ajax/apiErrorHandler'
import hostConfig from 'common/config'
import { paramsSerializer } from '@shopping/common'
import { isBrowser, isServer } from '..'

export const getHeaders = (headers: any) => {
  return isServer && headers ? { headers } : null
}

export const getHeadersWithClientIp = (headers: any) => {
  let userAgent = null
  let clientIp = null
  let referer = null
  if (headers) {
    userAgent = headers.hasOwnProperty('user-agent') && headers['user-agent']
    clientIp = headers.hasOwnProperty('x-forwarded-for')
      ? headers['x-forwarded-for']
      : headers.hasOwnProperty('x-real-ip')
      ? headers['x-real-ip']
      : headers.hasOwnProperty('n-client-ip') && headers['n-client-ip']
  }

  return isServer && headers
    ? {
        headers: {
          ...headers,
          referer,
          'user-agent': userAgent,
          'client-ip': clientIp,
        },
      }
    : null
}

export const axios = originalAxios.create({
  paramsSerializer,
  withCredentials: true,
  timeout: 5000,
})

axios.interceptors.request.use(config => {
  if (isServer && config.url.startsWith(`${hostConfig.apiVersion}/`)) {
    config.url = `http://127.0.0.1:${hostConfig.port}${config.url}`
  }
  if (isBrowser) {
    config.timeout = 10000
  }
  return config
})
axios.interceptors.response.use(null, error => apiErrorHandler(error))
